export default "__VITE_ASSET__BaCbBuyz__"